import { render, staticRenderFns } from "./AskedQuestion.vue?vue&type=template&id=106d72c8&scoped=true&"
import script from "./AskedQuestion.vue?vue&type=script&lang=js&"
export * from "./AskedQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AskedQuestion.vue?vue&type=style&index=0&id=106d72c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106d72c8",
  null
  
)

export default component.exports